import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { TableCell, TableRow, IconButton, Box } from '@material-ui/core';
import { Edit, Delete, Check, Close } from '@material-ui/icons';
import { StatusCode } from '../../domain/constants/StatusCode';
import ModalBarcode from '../common/ModalBarcode';
import StatusDrawer from './StatusDrawer';
import { useSyles } from './styles.style';
// Redux
import { useDispatch } from 'react-redux';
import { updateDrawer } from '../../redux/drawers/thunks';

const Drawer = ({ drawer }) => {
  const classes = useSyles();
  const {
    warehouses_str,
    barcode,
    rack,
    id,
    status_drawers_id,
    drawer_row,
    drawer_column,
    keys,
  } = drawer;

  const dispatch = useDispatch();
  const navigate = useNavigate(); // habilitar navigate para redirección

  const [showBarcode, setShowBarcode] = useState(false);
  const [showStatus, setShowStatus] = useState(false);

  // Confirmar si desea eliminarlo
  const confirmDeleteDrawer = (drawer) => {
    // preguntar al usuario
    Swal.fire({
      title: '¿Estas seguro?',
      text: 'Una gaveta que se elimina no se puede recuperar',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#FF5958',
      cancelButtonColor: '#C0BFC2',
      confirmButtonText: 'Si, eliminar!!',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.value) {
        // pasarlo al action
        changeStatusDrawer(drawer, StatusCode.deleted, 'Eliminado');
      }
    });
  };

  // función que redirige de forma programada
  const redirectEdition = (id) => {
    navigate(`/drawers/edit/${id}`, { replace: true });
  };

  const changeStatusDrawer = (drawer, status, text) => {
    const values = { ...drawer };
    values['status_drawers_id'] = status;
    dispatch(updateDrawer({ values, status, text }))
      .unwrap()
      .then((res) => {
        setTimeout(function () {
          navigate(0);
        }, 1000);
      });
  };

  const ActiveButton = () => {
    return (
      <>
        {status_drawers_id === StatusCode.active ? (
          <IconButton
            aria-label='check'
            size='medium'
            title='desactivar la gaveta'
            onClick={() =>
              changeStatusDrawer(drawer, StatusCode.inactive, 'Desactivado')
            }
          >
            <Check className={classes.check} />
          </IconButton>
        ) : (
          <IconButton
            aria-label='check'
            size='medium'
            title='activar la gaveta'
            onClick={() =>
              changeStatusDrawer(drawer, StatusCode.active, 'Activado')
            }
          >
            <Close color='error' />
          </IconButton>
        )}
      </>
    );
  };

  return (
    <TableRow key={id} className={classes.tableRow}>
      <TableCell component='th' scope='row'>
        {id}
      </TableCell>
      <TableCell>{warehouses_str}</TableCell>
      <TableCell>{rack}</TableCell>
      <TableCell>{drawer_row}</TableCell>
      <TableCell>{drawer_column}</TableCell>
      <TableCell>
        <StatusDrawer
          showStatus={showStatus}
          setShowStatus={setShowStatus}
          list={keys}
        />
      </TableCell>
      <TableCell>
        <Box sx={{ textAlign: 'center', width: 'max-content', margin: 'auto' }}>
          <IconButton
            aria-label='editar'
            size='medium'
            onClick={() => setShowBarcode(true)}
            title='imprimir código'
            variant='outlined'
          >
            <img width='25px' src='/barcode-icon.svg' alt='' />
          </IconButton>
          <Box sx={{ fontSize: '10px' }}>{barcode}</Box>
        </Box>
      </TableCell>
      <TableCell>
        <ActiveButton />
      </TableCell>
      <TableCell align='right'>
        <IconButton
          aria-label='editar'
          size='medium'
          onClick={() => redirectEdition(drawer.id)}
        >
          <Edit color='action' />
        </IconButton>
        <IconButton
          aria-label='borrar'
          size='medium'
          onClick={() => confirmDeleteDrawer(drawer)}
        >
          <Delete />
        </IconButton>
      </TableCell>
      {showBarcode && (
        <ModalBarcode barcode={barcode} onClose={() => setShowBarcode(false)} />
      )}
    </TableRow>
  );
};

export default Drawer;
